module.exports = __webpack_public_path__ + "media/1.c0cdf456.mp3";